import { render, staticRenderFns } from "./ConfigRoleUserAppChat.vue?vue&type=template&id=536083e4&scoped=true"
import script from "./ConfigRoleUserAppChat.vue?vue&type=script&lang=js"
export * from "./ConfigRoleUserAppChat.vue?vue&type=script&lang=js"
import style0 from "./ConfigRoleUserAppChat.vue?vue&type=style&index=0&id=536083e4&lang=css"
import style1 from "./ConfigRoleUserAppChat.vue?vue&type=style&index=1&id=536083e4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536083e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('536083e4')) {
      api.createRecord('536083e4', component.options)
    } else {
      api.reload('536083e4', component.options)
    }
    module.hot.accept("./ConfigRoleUserAppChat.vue?vue&type=template&id=536083e4&scoped=true", function () {
      api.rerender('536083e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/chat/ConfigRoleUserAppChat.vue"
export default component.exports